var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcn1M(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.267,
    height: 86.936,
    viewBox: "0 0 86.267 86.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn1-m",
    transform: "translate(-360 -4152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2274",
    "data-name": "Groupe 2274",
    transform: "translate(360 4152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 86.267,
    height: 86.936,
    rx: 20,
    fill: "rgba(255,186,70,0.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2602",
    "data-name": "Groupe 2602",
    transform: "translate(333.676 4123.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2935",
    "data-name": "Trac\\xE9 2935",
    d: "M92.849,45a1.814,1.814,0,0,1,1.064,1.926c-.046,1.67-.011,3.343-.014,5.015A1.466,1.466,0,0,1,92.259,53.6q-2.722.005-5.444,0A1.454,1.454,0,0,1,85.209,52c0-.4,0-.8,0-1.233H79.43c.453.33.877.619,1.281.935a18.307,18.307,0,0,1,7.065,12.136,2.387,2.387,0,0,0,1.272,2.145,4.06,4.06,0,0,1,1.577,5.069,4.3,4.3,0,0,1-8.189-.75A4.243,4.243,0,0,1,84.8,65.6c.206-.1.312-.2.283-.463a15.732,15.732,0,0,0-5.942-10.981,15.356,15.356,0,0,0-5.58-2.819c-.253-.071-.362.011-.494.213a4.223,4.223,0,0,1-7.235,0,.4.4,0,0,0-.539-.2A15.757,15.757,0,0,0,53.9,64.377c-.087.651-.093,1.1.641,1.5A4.055,4.055,0,0,1,56.463,70.3a4.294,4.294,0,0,1-3.293,3.337,4.181,4.181,0,0,1-4.434-1.751,4.229,4.229,0,0,1,1.675-6.268.883.883,0,0,0,.6-.834A18.4,18.4,0,0,1,56.8,52.875c.8-.763,1.713-1.413,2.574-2.116H53.691c0,.4,0,.822,0,1.245A1.454,1.454,0,0,1,52.083,53.6c-1.719,0-3.439-.031-5.157.015A1.815,1.815,0,0,1,45,52.546v-6.5L46.051,45h6.59c1.335.562,1.012,1.769,1.058,2.866h.549c3.5,0,7-.006,10.5.008.451,0,.779-.038.927-.554a2.512,2.512,0,0,1,.493-.753A4.625,4.625,0,0,1,68.877,45h1.146a.946.946,0,0,0,.174.074,4.323,4.323,0,0,1,3.192,2.54.675.675,0,0,0,.523.242c3.612.014,7.224.01,10.836.01H85.2c.046-1.1-.277-2.3,1.058-2.866Z",
    transform: "translate(0 0)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2936",
    "data-name": "Trac\\xE9 2936",
    d: "M125.112,45a4.625,4.625,0,0,0-2.707,1.567,2.512,2.512,0,0,0-.493.753c-.149.516-.476.556-.927.554-3.5-.014-7-.008-10.5-.008h-.549c-.046-1.1.277-2.3-1.058-2.866Z",
    transform: "translate(-56.235 0)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2937",
    "data-name": "Trac\\xE9 2937",
    d: "M270.428,45c-1.335.562-1.012,1.769-1.058,2.866h-.454c-3.612,0-7.224,0-10.836-.01a.675.675,0,0,1-.523-.242,4.323,4.323,0,0,0-3.192-2.54.946.946,0,0,1-.174-.074Z",
    transform: "translate(-184.169 0)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2938",
    "data-name": "Trac\\xE9 2938",
    d: "M153.1,150.238v9.938c0,1.1.011,2.2-.013,3.294a.613.613,0,0,1-.284.447,4.256,4.256,0,0,0-.833,7.335,4.26,4.26,0,0,0,6.78-2.75,4.17,4.17,0,0,0-2.46-4.555c-.2-.094-.331-.174-.33-.439q.015-6.518.009-13.035a1.036,1.036,0,0,1,.033-.15c.1.133.191.231.264.339q5.374,8.058,10.746,16.117a1.471,1.471,0,0,1-.09,2.151,18.327,18.327,0,0,0-4.811,9.266c-.015.076-.038.151-.07.278a6.193,6.193,0,0,0-.818-.246,19.561,19.561,0,0,0-2.588-.347c-2.243-.049-4.487-.009-6.731-.019a11.389,11.389,0,0,0-4.849.644c-.19-.733-.346-1.411-.542-2.077a17.632,17.632,0,0,0-4.054-7.152c-.087-.093-.175-.185-.26-.28a1.512,1.512,0,0,1-.161-2.187q2.046-3.08,4.1-6.155l6.59-9.885C152.825,150.629,152.925,150.493,153.1,150.238Z",
    transform: "translate(-85.088 -92.65)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2939",
    "data-name": "Trac\\xE9 2939",
    d: "M177.33,410.863q-4.033,0-8.066,0a2.415,2.415,0,0,1-.75-.1,1.351,1.351,0,0,1-.851-1.8,5.783,5.783,0,0,1,5.4-3.912q4.295-.052,8.591,0a5.788,5.788,0,0,1,5.4,3.918,1.392,1.392,0,0,1-1.325,1.891c-.779.028-1.559.008-2.338.008Z",
    transform: "translate(-107.907 -316.956)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2940",
    "data-name": "Trac\\xE9 2940",
    d: "M240.313,286.821a1.429,1.429,0,1,1-1.439-1.419A1.442,1.442,0,0,1,240.313,286.821Z",
    transform: "translate(-169.434 -211.647)",
    fill: "#ffaa1c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn1M);
export default __webpack_public_path__ + "static/media/icn1-m.9687fa7c65696d3be02d315c6837174c.svg";
export { ForwardRef as ReactComponent };